import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "user-overview"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "user-overview__chart grid" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "chart-heading" }
const _hoisted_7 = { class: "user-overview__details grid" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col xl:col-6" }
const _hoisted_10 = { class: "data-value" }
const _hoisted_11 = { class: "col xl:col-6" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "data-value" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "data-value" }
const _hoisted_16 = {
  key: 0,
  class: "col xl:col-6"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "data-value" }
const _hoisted_19 = {
  key: 1,
  class: "col xl:col-6"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "data-value" }
const _hoisted_22 = {
  key: 2,
  class: "col xl:col-6"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "data-value" }
const _hoisted_25 = {
  key: 1,
  class: "user-overview__address"
}
const _hoisted_26 = {
  key: 2,
  class: "user-overview__contacts"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_ProgressChart = _resolveComponent("ProgressChart")!
  const _component_Card = _resolveComponent("Card")!
  const _component_AddressList = _resolveComponent("AddressList")!
  const _component_EmergencyContactList = _resolveComponent("EmergencyContactList")!

  return (_ctx.model.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showAlerts)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              variant: "error",
              title: "alerts",
              icon: "exclamation-triangle"
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_ctx.model.isLockedOut)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
                        _createVNode(_component_TranslatedText, { path: "prompts.account-locked.title" }),
                        _cache[2] || (_cache[2] = _createTextVNode(". ", -1)),
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleUnlockUser && _ctx.handleUnlockUser(...args)))
                        }, [
                          _createVNode(_component_TranslatedText, { path: "prompts.account-locked.message" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.model.welcomeEmailSent)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                        _createVNode(_component_TranslatedText, { path: "prompts.welcome-email.title" }),
                        _cache[3] || (_cache[3] = _createTextVNode(". ", -1)),
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSendWelcomeEmail && _ctx.handleSendWelcomeEmail(...args)))
                        }, [
                          _createVNode(_component_TranslatedText, { path: "prompts.welcome-email.message" })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Card, {
              class: "chart",
              noBorder: "",
              noPadding: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("h5", _hoisted_6, [
                  _createVNode(_component_TranslatedText, { path: "progress.onboarding" })
                ]),
                (_ctx.model && _ctx.hotspotProgress)
                  ? (_openBlock(), _createBlock(_component_ProgressChart, {
                      overall: _ctx.overallPercentage,
                      trackProgress: _ctx.hotspotProgress,
                      key: _ctx.overallPercentage
                    }, null, 8, ["overall", "trackProgress"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _createVNode(_component_TranslatedText, { path: "models.user-details.plural" })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, [
              _createVNode(_component_TranslatedText, { path: "form.email-address" }),
              _cache[4] || (_cache[4] = _createTextVNode(":", -1))
            ]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.model?.email), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.contactNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_TranslatedText, { path: "form.telephone-number" }),
                    _cache[5] || (_cache[5] = _createTextVNode(":", -1))
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.contactNumber), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", null, [
              _createVNode(_component_TranslatedText, { path: "form.cohorts" }),
              _cache[6] || (_cache[6] = _createTextVNode(":", -1))
            ]),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.groupNames), 1)
          ]),
          (!_ctx.hiddenUserFields.includes('startDate'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_ctx.startDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("label", null, [
                        _createVNode(_component_TranslatedText, { path: "form.start-date" }),
                        _cache[7] || (_cache[7] = _createTextVNode(":", -1))
                      ]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.startDate), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hiddenUserFields.includes('endDate'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_ctx.endDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("label", null, [
                        _createVNode(_component_TranslatedText, { path: "form.end-date" }),
                        _cache[8] || (_cache[8] = _createTextVNode(":", -1))
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.endDate), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.employmentLength)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_ctx.startDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("label", null, [
                        _createVNode(_component_TranslatedText, { path: "form.length-of-employment" }),
                        _cache[9] || (_cache[9] = _createTextVNode(":", -1))
                      ]),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.employmentLength), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.userAddresses.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
              _createElementVNode("h5", null, [
                _createVNode(_component_TranslatedText, { path: "models.addresses.plural" })
              ]),
              _createVNode(_component_AddressList, {
                addresses: _ctx.userAddresses,
                readonly: true
              }, null, 8, ["addresses"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.emergencyContacts.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
              _createElementVNode("h5", null, [
                _createVNode(_component_TranslatedText, { path: "models.emergency-contact.plural" })
              ]),
              _createVNode(_component_EmergencyContactList, {
                contacts: _ctx.emergencyContacts,
                readonly: ""
              }, null, 8, ["contacts"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}